export const fieldTableTypes = {
    TEXT: String,
    EMAIL: String,
    DATE: Date,
    PHONE: Number,
    NUMBER: Number,
    PRICE: Number,
    ADDRESS: String,
    SELECT: String
};